import getInventory from './getInventory';
import getLottery from './getLottery';
import LotteryModel from '@models/LotteryModel';
import DrawModel from '@models/DrawModel';

export default async function (id, isEspecial = false) {
  try {
    id = parseInt(id, 10)
    const [inventory, lotteryInfo] = await Promise.all([
      getInventory(),
      getLottery(id)
    ])
    if (!inventory || !lotteryInfo) return null
    const nextDraw = inventory.customDrawsOnSale
      ? inventory.customDrawsOnSale
        .sort((a, b) => {
          return (
            +(a.drawDate > b.drawDate) || +(a.drawDate === b.drawDate) - 1
          )
        })
        .find((a) => {
          return a.lotteryID === id && a.isEspecial === isEspecial
        })
      : null

    const lottery = new LotteryModel(lotteryInfo, isEspecial)
    if (isEspecial) {
      lottery.haisEspecialsDuration =
        inventory.allowsEspecialDrawDuration || false
    }

    return {
      nextDraw: nextDraw ? new DrawModel(nextDraw) : null,
      lottery
    }
  } catch (error) {
    console.error(error)
    return new Error(error)
  }
}
